// src/components/common/ProgressBar.jsx
import React from 'react';

const ProgressBar = ({ steps, currentStep }) => {
  return (
    <div className="mt-6">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const isActive = index + 1 === currentStep;
          const isCompleted = index + 1 < currentStep;
          
          return (
            <div 
              key={index} 
              className={`flex flex-col items-center w-full ${
                index === steps.length - 1 ? '' : 'relative'
              }`}
            >
              {/* Step connector line */}
              {index !== steps.length - 1 && (
                <div 
                  className={`absolute top-4 w-full h-0.5 ${
                    isCompleted ? 'bg-orange-600' : 'bg-gray-200'
                  }`}
                />
              )}
              
              {/* Step circle */}
              <div 
                className={`z-10 flex items-center justify-center w-8 h-8 rounded-full ${
                  isActive 
                    ? 'bg-orange-600 text-white border border-orange-600' 
                    : isCompleted 
                      ? 'bg-orange-600 text-white' 
                      : 'bg-white text-gray-400 border border-gray-200'
                }`}
              >
                {isCompleted ? (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                ) : (
                  index + 1
                )}
              </div>
              
              {/* Step label */}
              <div className="mt-2 text-xs text-center">
                <span 
                  className={`
                    ${isActive ? 'text-orange-600 font-medium' : ''}
                    ${isCompleted ? 'text-orange-600' : 'text-gray-500'}
                  `}
                >
                  {step}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressBar;